'use client';

import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useHandleApp } from '@/modules/wello-app/_hooks/useHandleApp';
import { MESSAGE_KEYWORD } from '@/modules/wello-app/_utils/reserved-keywords';
import { STATUS_COLOR, useDeviceInfoStore } from '@/stores/DeviceStore';
interface UseStatusBarColorProps {
  color: string;
}
export const useStatusBarColor = t0 => {
  const $ = _c(7);
  const {
    color
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: MESSAGE_KEYWORD.STATUS_COLOR
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    request: requestStatusColor
  } = useHandleApp(t1);
  const [appVersion, setAppStatusColor] = useDeviceInfoStore(useShallow(_temp));
  let t2;
  let t3;
  if ($[1] !== appVersion || $[2] !== color || $[3] !== requestStatusColor || $[4] !== setAppStatusColor) {
    t2 = () => {
      if (!appVersion) {
        return;
      }
      const changeStatusColor = color_0 => {
        requestStatusColor({
          color: color_0
        });
        setAppStatusColor(color_0);
      };
      changeStatusColor(color);
      return () => changeStatusColor(STATUS_COLOR.DEFAULT);
    };
    t3 = [appVersion, color, requestStatusColor, setAppStatusColor];
    $[1] = appVersion;
    $[2] = color;
    $[3] = requestStatusColor;
    $[4] = setAppStatusColor;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useLayoutEffect(t2, t3);
};
function _temp(state) {
  return [state.appVersion, state.setAppStatusColor];
}